module.exports = __webpack_public_path__ + "static/slide9-318x245-40f6841b97ed68f0bbfbe4cd0c586b28.gif";